import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/company";

export const Route = createFileRoute("/impresszum")({
  head: () => ({
    meta: [
      { title: "Impresszum | LAKROSZ Autószerviz" },
      {
        name: "description",
        content:
          "A LAKROSZ Autószerviz weboldal üzemeltetőjének hivatalos adatai és tárhelyszolgáltatójának elérhetősége.",
      },
      { property: "og:title", content: "Impresszum | LAKROSZ Autószerviz" },
      {
        property: "og:description",
        content: "Az üzemeltető hivatalos adatai és tárhelyszolgáltató elérhetősége.",
      },
      { property: "og:url", content: "https://lakroszautoszerviz.com/impresszum" },
      { property: "og:type", content: "article" },
    ],
    links: [
      { rel: "canonical", href: "https://lakroszautoszerviz.com/impresszum" },
    ],
  }),
  component: ImprintPage,
});

function Row({ label, value }: { label: string; value: string }) {
  const missing = value.includes("HIÁNYZÓ");
  return (
    <div className="flex flex-col sm:flex-row sm:gap-3 py-2 border-b border-border/60 last:border-b-0">
      <div className="sm:w-64 shrink-0 text-sm text-muted-foreground">{label}</div>
      <div className={`text-sm ${missing ? "text-foreground/60 italic" : ""}`}>{value}</div>
    </div>
  );
}

function ImprintPage() {
  return (
    <LegalLayout title="Impresszum" subtitle="A weboldal üzemeltetőjének adatai">
      <section>
        <h2 className="font-display text-2xl mt-4 mb-4">Szolgáltató adatai</h2>
        <div className="rounded-2xl border border-border bg-surface p-6">
          <Row label="Hivatalos cégnév / egyéni vállalkozó neve" value={COMPANY.legalName} />
          <Row label="Márkanév" value="LAKROSZ Autószerviz" />
          <Row label="Székhely" value={COMPANY.address.full} />
          <Row label="Telephely / szolgáltatás helye" value="3300 Eger, Vécseyvölgy utca 99." />
          <Row label="Adószám" value={COMPANY.registry.taxNumber} />
          <Row label="Cégjegyzékszám / nyilvántartási szám" value={COMPANY.registry.registrationNumber} />
          <Row label="Képviselő / kapcsolattartó" value={COMPANY.registry.representative} />
          <Row label="Telefonszám" value={COMPANY.contact.phone} />
          <Row label="E-mail cím" value={COMPANY.contact.email} />
          <Row label="Weboldal" value="lakroszautoszerviz.com" />
        </div>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-4">Tárhelyszolgáltató adatai</h2>
        <div className="rounded-2xl border border-border bg-surface p-6">
          <Row label="Tárhelyszolgáltató neve" value={COMPANY.hosting.name} />
          <Row label="Tárhelyszolgáltató székhelye" value={COMPANY.hosting.address} />
          <Row label="Tárhelyszolgáltató e-mail címe" value={COMPANY.hosting.email} />
          <Row label="Tárhelyszolgáltató weboldala" value={COMPANY.hosting.website} />
        </div>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-4">Egyéb</h2>
        <div className="rounded-2xl border border-border bg-surface p-6">
          <Row label="Szakmai engedély / tevékenységi kör" value="Gépjármű javítása, karbantartása – TEÁOR’25: 9531 (korábban TEÁOR’08: 4520)" />
          <Row label="Kamara / nyilvántartó hatóság" value="Nemzeti Adó- és Vámhivatal – Egyéni Vállalkozók Nyilvántartása" />
          <Row label="Területileg illetékes gazdasági kamara" value="Heves Vármegyei Kereskedelmi és Iparkamara" />
        </div>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">Szerzői jog</h2>
        <p>
          A weboldalon található tartalmak (szövegek, képek, logók, grafikák) a LAKROSZ
          Autószerviz szellemi tulajdonát képezik. Engedély nélküli felhasználásuk tilos.
        </p>
      </section>
    </LegalLayout>
  );
}
